import * as React from 'react';
import { TitleWithIcon } from '../../components/TitleWithIcon/TitleWithIcon.js';

const InvoiceForm = ({ invoiceForm , title  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(TitleWithIcon, {
        icon: "newsletter",
        label: title
    }), invoiceForm)
;

export { InvoiceForm };
//# sourceMappingURL=InvoiceForm.js.map
